// extracted by mini-css-extract-plugin
module.exports = {"preview":"StoreUrlInput_preview__2dJy_","suffix":"StoreUrlInput_suffix__1x-IF"};